/**
 * This is the input field widget
 *
 * optional @prop type {String} type of input
 * optional @prop widgetId {String} widget ID
 * optional @prop isRequired {Bool} is the input field required
 * optional @prop isFocused {Bool} is the input field focused
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { omit } from 'lodash';
import displayName from 'component-lib/displayName';
import isDeprecated from 'component-lib/isDeprecated';

import styles from './InputField.scss';

export default class InputField extends Component {
    static displayName = displayName('Widgets/InputField');

    static propTypes = {
        type: PropTypes.string,
        widgetId: PropTypes.string,
        isRequired: PropTypes.bool,
        isFocused: PropTypes.bool,
        isForceFocus: PropTypes.bool,
        value: PropTypes.string,
        className: PropTypes.string,
    };

    static defaultProps = {
        className: '',
        type: 'text',
        isRequired: false,
        isFocused: false,
        isForceFocus: false,
        value: '',
        widgetId: '',
    };

    constructor(props) {
        super(props);

        isDeprecated(InputField, 'Forms/InputFields/InputField');
    }

    componentDidMount() {
        if (this.props.isFocused) this.focusOnWidget();
    }

    componentDidUpdate() {
        const { isForceFocus } = this.props;

        if (isForceFocus) this.focusOnWidget();
    }

    focusOnWidget() {
        $(this.inputField)
            .focus()
            .val(this.props.value);
    }

    render() {
        const widgetProps = omit(this.props, [
            'isRequired',
            'isFocused',
            'isForceFocus',
            'styleName',
            'styles',
            'className',
            'widgetId',
        ]);

        let className = styles.input;
        if (this.props.className) {
            className += ` ${this.props.className}`;
        }

        return (
            <input
                {...widgetProps}
                className={className}
                ref={(c) => {
                    this.inputField = c;
                }}
            />
        );
    }
}
